// services/statistic-data/hooks/useReservationStatistic.ts

import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ReservationStatisticResponseSchema } from "../response/ReservationStatisticResponse";

const API_VERSION = "v4";

// Interface untuk parameter filter
interface ParamsStatistic {
    property_id?: string;
    start_date?: string;
    end_date?: string;
}

// Interface untuk props yang diterima oleh hook
interface ReservationStatisticProps {
    filters: ParamsStatistic;
}

const useReservationStatistic = (query: ReservationStatisticProps) => {
    return useQuery({
        // Kunci query yang unik
        queryKey: [
            'reservation-statistic',
            ...Object.entries(query.filters ?? {})
                .map(([key, value]) => `${key}:${value}`),
        ],
        queryFn: async () => {
            try {
                const params = {
                    filter: Object.fromEntries(
                        Object.entries(query.filters ?? {}).filter(([_key, value]) => value)
                    ),
                };

                const response = await privateApi.get(`/${API_VERSION}/channel-manager/statistics/reservation`, { params });

                const validationResult = ReservationStatisticResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Reservation Statistic data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Reservation Statistic`, error);
                throw error;
            }
        },
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default useReservationStatistic;